import Widget from "./base.js";
import { setCookie, getCookie } from "tpm-utils";

//put this somewhere near the site footer, other components use this data
export class FundraiserStatusFetcherWidget extends Widget {
	componentWillMount() {
		if (!window.tpm_fb && !window.tpm_fm) return;

		fetch(
			// `https://accounts.${document.location.hostname}/doesspress/fundraiser-status`,
			`https://accounts.talkingpointsmemo.com/doesspress/fundraiser-status`,
			{
				method: "GET",
				credentials: "omit",
			}
		)
			.then((resp) => {
				return resp.json();
			})
			.then((resp) => {
				if (window.tpm_fb) window.tpm_fb.setup(resp);
				if (window.tpm_fm) window.tpm_fm.setup(resp);
				window.tpm_fundraiser_status = resp;
			})
			.catch((resp) => {
				console.warn("fundraiser-status request failed");
				console.warn(resp);
			});
	}

	renderContent() {
		<div></div>;
	}
}
